import axios from 'axios';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import VuexORMSearch from '@vuex-orm/plugin-search'
import Address from './ORM/Address';
import AddressType from './ORM/AddressType';
import Contact from './ORM/Contact';
import ContactType from './ORM/ContactType';
import Contract from './ORM/Contract';
import ContractType from './ORM/ContractType';
import Customer from './ORM/Customer';
import CustomerType from './ORM/CustomerType';
import Environment from './ORM/Environment';
import EnvironmentType from './ORM/EnvironmentType';
import Imperative from './ORM/Imperative';
import ImperativeType from './ORM/ImperativeType';
import License from './ORM/License';
import LicenseType from './ORM/LicenseType';
import Name from './ORM/Name';
import NameType from './ORM/NameType';
import Note from './ORM/Note';
import NoteType from './ORM/NoteType';
import RegionType from "./ORM/RegionType";
import Billing from "./ORM/Billing";
import Invoice from "./ORM/Invoice.js";
import InvoiceItem from "./ORM/InvoiceItem.js";
import Sample from './ORM/Sample'
import SampleCertType from './ORM/SampleCertType'
import SampleNote from './ORM/SampleNote'
import SampleNoteType from './ORM/SampleNoteType'
import SampleTest from './ORM/SampleTest'
import SampleTestType from './ORM/SampleTestType'
import SampleType from './ORM/SampleType'
import Unit from './ORM/Unit'
import Subscription from './ORM/Subscription'
import PhoneNumber from './ORM/PhoneNumber'
import CustomerSearch from "./ORM/CustomerSearch";
import EmailTemplate from "./ORM/EmailTemplate";
import ReleaseQueue from "./ORM/ReleaseQueue";
import SampleFlagType from "@/Store/ORM/SampleFlagType";
import SampleFlag from "@/Store/ORM/SampleFlag";
import SampleCertTypeTestRequirement from "@/Store/ORM/SampleCertTypeTestRequirement";
import BillingPackage from "@/Store/ORM/FirebaseORM/BillingPackage";
import SampleCertTypeCategory from "@/Store/ORM/SampleCertTypeCategory";
import BillingTestPrice from "@/Store/ORM/FirebaseORM/BillingTestPrice";
import BillingBundleDiscount from "@/Store/ORM/FirebaseORM/BillingBundleDiscount";
import BillingTestPair from "@/Store/ORM/FirebaseORM/BillingTestPair";
import BillingPromotion from "@/Store/ORM/FirebaseORM/BillingPromotion";
import BillingSpecial from "@/Store/ORM/FirebaseORM/BillingSpecial";
import BillingInvoice from "@/Store/ORM/FirebaseORM/BillingInvoice";
import User from "@/Store/ORM/FirebaseORM/User";
import BillingFixedPrice from "./ORM/FirebaseORM/BillingFixedPrice";
import BillingSeparatedLineItems from "./ORM/FirebaseORM/BillingSeparatedItem";
import ReportedSample from "@/Store/ORM/ReportedSample";
VuexORM.use(VuexORMAxios, {
    axios,
    // baseURL: "https://belit.conflabs.com/api/v1",
    // baseURL: "https://test-rec.conflabs.com/api/v1",
    baseURL: process.env.VUE_APP_BELIT_API,
    headers:{
        "Accept": "application/json",
        "Authorization": process.env.VUE_APP_BELIT_API_KEY,
    },
});
VuexORM.use(VuexORMSearch,{});
const database = new VuexORM.Database();
// Register ORM Models
database.register(Address);
database.register(AddressType);
database.register(Contact);
database.register(ContactType);
database.register(Contract);
database.register(ContractType);
database.register(Customer);
database.register(CustomerType);
database.register(Environment);
database.register(EnvironmentType);
database.register(Imperative);
database.register(ImperativeType);
database.register(License);
database.register(LicenseType);
database.register(Name);
database.register(NameType);
database.register(Note);
database.register(NoteType);
database.register(RegionType);
database.register(Billing);
database.register(Invoice);
database.register(InvoiceItem);
database.register(Sample);
database.register(SampleCertType);
database.register(SampleNote);
database.register(SampleNoteType);
database.register(SampleTest);
database.register(SampleTestType);
database.register(SampleType);
database.register(Unit);
database.register(Subscription);
database.register(PhoneNumber);
database.register(CustomerSearch);
database.register(EmailTemplate);
database.register(ReleaseQueue);
database.register(SampleFlagType);
database.register(SampleFlag);
database.register(SampleCertTypeTestRequirement);
database.register(SampleCertTypeCategory);

//reported models
database.register(ReportedSample);

//firebase models
database.register(BillingPackage);
database.register(BillingTestPrice);
database.register(BillingBundleDiscount);
database.register(BillingTestPair);
database.register(BillingPromotion);
database.register(BillingSpecial);
database.register(BillingInvoice);
database.register(BillingFixedPrice);
database.register(User);
database.register(BillingSeparatedLineItems);
export default VuexORM.install(database);
